// ============================================================================
// FIRESTORE PATHS — SINGLE POINT OF TRUTH
// ARQUIVO: src/shared/constants/firestorePaths.js
// RESPONSABILIDADE: Todos os caminhos de coleção do Firestore centralizados.
//   Retornam arrays de segmentos para uso com collection(db, ...segments)
//   e doc(db, ...segments, docId).
// ============================================================================

const DEFAULT_APP_ID = 'portalrda-f312d';

export const FS = {
  // Entity collections (usar com collection(db, ...FS.documents(appId)))
  documents: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'documents'],
  clients: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'clients'],
  processes: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'processes'],
  libraryItems: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'library_items'],
  fileHubAttachments: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'file_hub_attachments'],
  officeNotifications: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'office_notifications'],
  autosWorkspaces: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'autos_workspaces'],
  notifications: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'notifications'],
  agendaEvents: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'agenda_events'],
  documentAcknowledgements: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'document_acknowledgements'],
  matters: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'matters'],
  portalPieceApprovals: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'portal_piece_approvals'],
  rdaTriage: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'rda_triage'],
  financialLedger: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'financial_ledger'],
  timesheetEntries: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'timesheet_entries'],
  invoices: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'invoices'],
  clientTasks: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'client_tasks'],
  personalPostings: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'personal_postings'],
  calendarEvents: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'calendar_events'],

  // Nested paths
  workspaceMovements: (workspaceId, appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'autos_workspaces', workspaceId, 'movements'],
  // Camada caderno_notas (Constituição Processos ART. 20 — 01/09/2026):
  // subcoleção irmã de movements para o "histórico processual completo"
  // (notas de trabalho + transcrição de atos oficiais). Nunca se mistura
  // com movements no mesmo documento.
  workspaceCadernoNotas: (workspaceId, appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'autos_workspaces', workspaceId, 'caderno_notas'],
  userProcesses: (appId = DEFAULT_APP_ID, userId) => ['artifacts', appId, 'users', userId, 'processes'],
  userBookmarks: (appId = DEFAULT_APP_ID, userId) => ['artifacts', appId, 'users', userId, 'bookmarks'],
  userExamResults: (appId = DEFAULT_APP_ID, userId) => ['artifacts', appId, 'users', userId, 'exam_results'],
  academyProgress: (appId = DEFAULT_APP_ID, userId) => ['artifacts', appId, 'users', userId, 'academy_progress'],
  clientNotifications: (appId = DEFAULT_APP_ID, clientId) => ['artifacts', appId, 'public', 'data', 'clients', clientId, 'notifications'],
  clientNotes: (appId = DEFAULT_APP_ID, clientId) => ['artifacts', appId, 'public', 'data', 'clients', clientId, 'notes'],
  clientDocuments: (appId = DEFAULT_APP_ID, clientId) => ['artifacts', appId, 'public', 'data', 'clients', clientId, 'documents'],

  // Admin
  contractsHistory: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'admin', 'contracts_history'],
  auditLogs: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', '_audit_logs'],

  // Questions / Knowledge Base
  questions: (appId = DEFAULT_APP_ID) => ['artifacts', appId, 'public', 'data', 'questions_v1'],

  // Root-level collections (legado / global)
  alertInbox: () => ['alert_inbox'],
  clientsRoot: (clientId) => ['clients', clientId],
  rootRdaTriage: () => ['rda_triage'],
  uniqueCpfs: (cpfDigits) => ['unique_cpfs', cpfDigits],
  magicLinkTokens: (oobCode) => ['magic_link_tokens', oobCode],
  rootDocuments: (docId) => ['documents', docId],
  rootDocumentsCol: () => ['documents'],
};

export default FS;
